import $api from "../../../axios"
import { ICreateProject } from "../types/project.type"

const projectsPath = "/projects"

const getProjects = async () => {
  const response = await $api.get(projectsPath + "/")
  return response.data
}

const createProject = async (project: ICreateProject) => {
  const response = await $api.post(projectsPath + "/create", project)
  return response.data
}

export default {
  getProjects,
  createProject,
}
